import React from 'react';

import { ReactComponent as SortAsc } from 'helpers/icons/Table/ASCArrow.svg';
import { ReactComponent as SortDesc } from 'helpers/icons/Table/DESCArrow.svg';

export const sortDirectionsDefaultIcon = {
  ascend: <SortAsc className="placeholder-sort-icon" />,
  descend: <SortDesc className="placeholder-sort-icon" />,
};
